import { render } from "./LoadingComponent.vue?vue&type=template&id=303c789f"
import script from "./LoadingComponent.vue?vue&type=script&lang=js"
export * from "./LoadingComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/components/LoadingComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "303c789f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('303c789f', __exports__)) {
    api.reload('303c789f', __exports__)
  }
  
  module.hot.accept("./LoadingComponent.vue?vue&type=template&id=303c789f", () => {
    api.rerender('303c789f', render)
  })

}


export default __exports__